// Client for the IFPRI Essential Commodities admin endpoints (/admin/ifpri/*).
export const API_URL = process.env.REACT_APP_URL;

const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem("token"));
  } catch (e) {
    return null;
  }
};

const authFetch = async (path, options = {}) => {
  const headers = new Headers(options.headers || {});
  headers.set("Accept", "application/json");
  if (options.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const response = await fetch(`${API_URL}${path}`, { ...options, headers });
  const text = await response.text();
  const json = text ? JSON.parse(text) : null;
  if (!response.ok) {
    const message = (json && (json.message || json.error)) || response.statusText;
    throw new Error(Array.isArray(message) ? message.join(", ") : message);
  }
  return json;
};

/** Creates a one-time upload link (replaces any open one). */
export const createUploadSession = () =>
  authFetch("/admin/ifpri/upload-session", { method: "POST" });

export const listImports = (limit = 20) =>
  authFetch(`/admin/ifpri/imports?limit=${limit}`);

export const getImport = (id) => authFetch(`/admin/ifpri/imports/${id}`);
